import React from 'react';
import { Dialog, DialogContent, DialogTitle, Slide, Grid, Typography, Box, CardMedia, IconButton } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { GlobalTheme } from '../../theme';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import TourForm from '../form/tourForm';
import bgVideo from './assets/images/bgVideo.mp4';

const Transition = React.forwardRef(function Transition(props, ref) {
    const isMobile = useMediaQuery(GlobalTheme.breakpoints.down('md'));
    return <Slide direction={isMobile ? "up" : "down"} ref={ref} {...props} />;
});

const OfferDialog = ({ open, handleClose, isFromOurService, title }) => {
    const [maxWidth] = React.useState('lg');
    // const isFromOurService = Boolean(selectedOfferTitle);

    return (
        <Box sx={{ position: 'relative' }}>

            <Dialog
                id='specialOfferDialog'
                open={open}
                TransitionComponent={Transition}
                keepMounted
                maxWidth={maxWidth}
                aria-describedby="titleSpecialOffer"
                sx={{
                    '& .MuiDialog-paper': {
                        overflow: 'unset',
                    }
                }}
            >
                <IconButton aria-label="Close" onClick={handleClose} sx={{
                    position: { xs: 'fixed', sm: 'absolute' }, zIndex: 1, top: { xs: 'calc(100% - 84vh)', sm: -20 }, right: { xs: 0, sm: -20 }, color: 'common.bodyTxt', p: 1, m: 1, backgroundColor: 'common.grayLight', borderRadius: 50, boxShadow: 3,
                    '&:hover, &:focus': {
                        backgroundColor: 'common.grayLight', boxShadow: 4,
                    }

                }}>
                    <CloseOutlinedIcon />
                </IconButton>
                <DialogContent sx={{
                    p: 0, display: 'flex',
                    position: { xs: 'fixed', sm: 'relative' },

                    bottom: { xs: 0, sm: 'unset' },
                    left: { xs: 0, sm: 'unset' },
                    right: { xs: 0, sm: 'unset' },
                    backgroundColor: 'common.white',
                    width: { xs: '100vw', sm: 'auto' },
                    overflow: { xs: 'hidden', sm: 'unset' },
                    height: { xs: '80vh', sm: 'auto' },
                    maxHeight: { xs: '80vh', sm: 'unset' },

                }} id='titleSpecialOffer'>
                    <Grid container flexWrap={isFromOurService ? 'wrap' : 'nowrap'}>
                        {isFromOurService !== 0 && (
                            <Grid id="offerMedia" item xs={12} sm={9} sx={{
                                '&.MuiGrid-item': {
                                    py: 0
                                },
                                display: { xs: 'none', sm: 'flex' }
                            }}>
                                {/* <img src="https://as1.ftcdn.net/v2/jpg/08/07/90/66/1000_F_807906668_GrFTE0LhDytMU9iTpICO39SQuGD7VK1K.jpg" alt="Offer" style={{ width: '100%' }} /> */}
                                <CardMedia
                                    component="video"
                                    objectFit="cover"
                                    width="100%"

                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={bgVideo}
                                    sx={{
                                        height: { xs: '100%', md: 825 },
                                        objectFit: 'cover',
                                    }}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={isFromOurService ? 3 : 12} justifyContent='center' display='flex' flexDirection='column' px={{ xs: 4, md: 0 }}>

                            <DialogTitle component='span' sx={{
                                px: 0, mb: isFromOurService ? 2 : 0,
                                pt: { xs: 3, md: 0 },



                            }} color='primary' variant={isFromOurService ? 'h1' : 'h2'} textAlign='center'>
                                {isFromOurService ? 'Available 40% Discount' : <Box component='span' sx={{
                                    '& p': {
                                        mb: 0
                                    }
                                }} dangerouslySetInnerHTML={{ __html: title }} />}

                                {isFromOurService !== 0 && (
                                    <Typography variant='h4' fontWeight='400' component='span' sx={{
                                        color: 'common.bodyTxt',
                                        display: 'block',
                                    }}>on your first trip with us!</Typography>
                                )}
                            </DialogTitle>
                            {isFromOurService !== 0 && (
                                <Typography variant='body1' component='p' sx={{ mb: 2, textAlign: 'center' }}>
                                    Send us your basic information and let us curate your trip
                                </Typography>
                            )}

                            <Box id='foem' px={{ md: 4 }} mb={{ xs: 4, md: isFromOurService ? 0 : 5 }}
                                sx={{
                                    height: { xs: '100%', md: 'unset' },
                                    overflowY: { xs: 'auto', md: 'unset' },
                                    '&::-webkit-scrollbar': {
                                        display: 'none'
                                    }
                                }}>
                                <TourForm />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </Box >
    );
};

export default OfferDialog;